import React, { useEffect, useState } from 'react';
import { Player } from '../../types';

interface CustomDragPreviewProps {
  player: Player;
  isVisible: boolean;
}

export const CustomDragPreview: React.FC<CustomDragPreviewProps> = ({ player, isVisible }) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    if (!isVisible) return;

    const handleMouseMove = (e: MouseEvent) => {
      // Usar clientX y clientY para posición relativa a la ventana
      setPosition({ 
        x: e.clientX + 15, // Offset para que no esté exactamente sobre el cursor
        y: e.clientY + 15 
      });
    };

    // También manejar el evento drag para mejor seguimiento durante el arrastre
    const handleDrag = (e: DragEvent) => {
      if (e.clientX !== 0 && e.clientY !== 0) {
        setPosition({ 
          x: e.clientX + 15,
          y: e.clientY + 15 
        });
      }
    };

    // Agregar listeners al documento para capturar todos los movimientos
    document.addEventListener('mousemove', handleMouseMove, { passive: true });
    document.addEventListener('drag', handleDrag, { passive: true });
    
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('drag', handleDrag);
    };
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: position.y,
        left: position.x,
        zIndex: 9999,
        pointerEvents: 'none',
        backgroundColor: 'rgba(0, 0, 0, 0.9)',
        borderRadius: '12px',
        padding: '8px 12px',
        border: '2px solid #FFD700',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        fontSize: '14px',
        fontWeight: '600',
        color: '#FFFFFF',
        minWidth: '120px',
        backdropFilter: 'blur(4px)',
        transform: 'translate(0, 0)',
        transition: 'none',
        userSelect: 'none',
        whiteSpace: 'nowrap'
      }}
    >
      {/* GIF de persona corriendo */}
      <div
        style={{
          width: '16px',
          height: '16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '16px',
          animation: 'running 0.6s steps(4) infinite'
        }}
      >
        🏃
      </div>
      
      {/* Nombre del jugador */}
      <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
        {player.name}
      </span>
      
      <style>
        {`
          @keyframes running {
            0% { transform: translateX(0px) rotateY(0deg); }
            25% { transform: translateX(2px) rotateY(0deg); }
            50% { transform: translateX(4px) rotateY(0deg); }
            75% { transform: translateX(2px) rotateY(0deg); }
            100% { transform: translateX(0px) rotateY(0deg); }
          }
        `}
      </style>
    </div>
  );
}; 